module.exports = __webpack_public_path__ + "img/index-data-bg-m.a9bd5714.jpg";